import GeneralPopup from "../shared/GeneralPopup";
import { auth } from "../services/auth";
import { WalletIcon } from "@heroicons/react/24/solid";
import CoinbaseIcon from "../../src/assets/images/Coinbase-icon-symbol-1.png";
import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AppContext from "../contexts/appContext";
import InstaImages from "../components/social/InstaImages";
import InstaDefault from "../components/social/InstaDefault";
import FacebookPage from "../components/social/FacebookPage";
import FacebookComment from "../components/social/FacebookComment";
import Youtube from "../components/social/Youtube";
import Soundcloud from "../components/social/Soundcloud";
import TikTokImages from "../components/social/TikTokImages";
import ItemPreview from "../components/OrderItem";
import TwitterPost from "../components/social/TwitterPost";
import {
  retrieveInsta,
  retrieveUserInsta,
  getTikTokPosts,
  getTwitterPosts,
  fetchUserTikTokPosts,
  fetchUserTwitterPosts,
  addCartItem,
} from "../services/posts";
import { Helmet } from "react-helmet";
import styles from "../css/posts.module.css";

export default function Posts() {
  const { menu } = useContext(AppContext);

  const [lastId, setLastId] = useState();
  const [postData, setPostData] = useState([]);
  const [selectedPosts, setSelectedPosts] = useState([]);
  const [products, setProducts] = useState([]);
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPopup, setPopup] = useState(false);
  const [selectedSubCategory, setSelectedSubCategory] = useState();
  const [selectedMenuItem, setSelectedMenuItem] = useState();
  const [youtube, setYoutube] = useState();
  const [twitterData, setTwitterData] = useState();
  const [socialLogo, setSocialLogo] = useState();
  const [metadataGlobal, setMetadataGlobal] = useState();
  const { username, email, serviceId, categoryId, subCategory, itemId, serviceItemId } =
    useParams();
  const navigate = useNavigate();
  const loggedUser = auth().getUser();
  const token = auth().getToken();

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const handleChangeFacebookComments = (value) => {
    if (products != null) {
      let tempProduct = [{ ...products[0], itemComment: value }];
      setProducts(tempProduct);
    }
  };

  const togglePopup = () => {
    setPopup(!showPopup);
  };

  const getSelectedService = (services) => {
    if (services === undefined && services === null) {
      return null;
    }
    const subcatergories = services
      ?.filter((ser) => ser.id == serviceId)[0]
      ?.category?.filter((cat) => cat.id == categoryId)[0]?.subcategory;
    const selectedSubCat = subcatergories?.filter((subCat) => subCat.id == subCategory)[0];
    const selectedMenuItem = selectedSubCat.menuItem.filter((item) => item.id == itemId);
    setSelectedSubCategory(selectedSubCat);
    setSelectedMenuItem(selectedMenuItem);

    return selectedSubCat;
  };

  useEffect(() => {
    getSelectedService(menu);
  }, [menu]);

  useEffect(() => {
    if (selectedSubCategory) {
      switch (selectedSubCategory.nameOfService) {
        case "InstaDefault":
          var instaData = JSON.parse(localStorage.getItem("InstaData"));
          setMetadataGlobal(instaData);
          addPost("", instaData, selectedSubCategory?.nameOfService);
          setSocialLogo("Insta");
          break;
        case "InstaImages":
        case "InstaComments":
        case "InstaCustomComments":
        case "InstaVideo":
          fetchInstaPosts();
          setMetadataGlobal(JSON.parse(localStorage.getItem("InstaData")));
          setSocialLogo("Insta");
          break;
        case "FacebookPage":
        case "FacebookPosts":
        case "FacebookVideo":
        case "FacebookComment":
        case "FacebookCustomComment":
        case "FacebookProfile":
        case "FacebookDefault":
          addPost("", null, selectedSubCategory?.nameOfService);
          setSocialLogo("Facebook");
          break;
        case "TwitterFollow":
          var twitterData = JSON.parse(localStorage.getItem("TwitterData"));
          setMetadataGlobal(twitterData);
          setTwitterData(twitterData);
          addPost("", twitterData, selectedSubCategory?.nameOfService);
          setSocialLogo("Twitter");
          break;
        case "TwitterPost":
          var twitterData = JSON.parse(localStorage.getItem("TwitterData"));
          setTwitterData(twitterData);
          setMetadataGlobal(twitterData);
          fetchTwitterPosts();
          setSocialLogo("Twitter");
          break;
        case "YoutubeVideo":
        case "YoutubeCustomComments":
        case "YoutubeChannel":
          const youtubeData = JSON.parse(localStorage.getItem("YoutubeData"));
          setYoutube(youtubeData);
          setMetadataGlobal(youtubeData);
          addPost("", youtubeData, selectedSubCategory?.nameOfService);
          setSocialLogo("Youtube");
          break;
        case "SoundCloudTrack":
        case "SoundCloudArtist":
          addPost("", null, selectedSubCategory?.nameOfService);
          setSocialLogo("SoundCloud");
          break;
        case "TikTokProfile":
          addPost(
            "",
            JSON.parse(localStorage.getItem("TikTokData")),
            selectedSubCategory?.nameOfService
          );
          setSocialLogo("TikTok");
          break;
        case "TikTokPost":
        case "TikTokComments":
        case "TikTokCustomComments":
          fetchTikTokPosts();
          setSocialLogo("TikTok");
          break;
        default:
          break;
      }
    }
  }, [selectedMenuItem]);

  const fetchInstaPosts = () => {
    setIsLoading(true);
    retrieveInsta(username, config)
      .then((response) => {
        setLastId(response?.data?.next_max_id);
        setPostData(response?.data.items);
        setHasError(false);
        setError("");
      })
      .catch((error) => {
        setHasError(true);
        setError("Invalid fetching, please try again");
      })
      .finally(() => {
        setIsLoading(false);
      });
    return postData;
  };

  const fetchTikTokPosts = () => {
    setIsLoading(true);
    const tikTokData = JSON.parse(localStorage.getItem("TikTokData"));
    if (tikTokData == undefined) {
      setHasError(true);
      setError("Invalid fetching, please try again");
      setIsLoading(false);
      return null;
    }
    getTikTokPosts(tikTokData, config)
      .then((response) => {
        setLastId(response?.data?.max_cursor);
        setPostData(response?.data?.aweme_list);
        setHasError(false);
      })
      .catch((error) => {
        setHasError(true);
        setError("Invalid fetching, please try again");
      })
      .finally(() => {
        setIsLoading(false);
      });
    return postData;
  };

  const fetchTwitterPosts = () => {
    setIsLoading(true);
    const twitterData = JSON.parse(localStorage.getItem("TwitterData"));
    if (twitterData == undefined) {
      setHasError(true);
      setError("Invalid fetching, please try again");
      setIsLoading(false);
      return null;
    }
    getTwitterPosts(twitterData, config)
      .then((response) => {
        setLastId(response?.data.continuation_token);
        setPostData(response?.data.results);
        setHasError(false);
      })
      .catch((error) => {
        setHasError(true);
        setError("Invalid fetching, please try again");
      })
      .finally(() => {
        setIsLoading(false);
      });
    return postData;
  };

  const loadMorePosts = () => {
    setIsLoading(true);
    retrieveUserInsta(username, lastId, config)
      .then((response) => {
        setLastId(response?.data?.next_max_id);
        setPostData(postData.concat(response.data.items));
        setHasError(false);
      })
      .catch((error) => {
        setHasError(true);
        setError("Invalid fetching, please try again");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const loadMorePostsTikTok = () => {
    setIsLoading(true);
    const tikTokData = JSON.parse(localStorage.getItem("TikTokData"));
    fetchUserTikTokPosts(tikTokData, lastId, config)
      .then((response) => {
        setLastId(response?.data?.max_cursor);
        setPostData(postData.concat(response.data.aweme_list));
        setHasError(false);
      })
      .catch((error) => {
        setHasError(true);
        setError("Invalid fetching, please try again");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const loadMorePostsTwitter = () => {
    setIsLoading(true);

    fetchUserTwitterPosts(twitterData, lastId, config)
      .then((response) => {
        // setLastId(response?.data[0].entries[response?.data[0].entries.length - 1].content?.value);
        // setPostData(postData.concat(response.data[0].entries));
        setLastId(response?.data.continuation_token);
        setPostData(response?.data.results);
        setHasError(false);
      })
      .catch((error) => {
        setHasError(true);
        setError("Invalid fetching, please try again");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const selectImage = (value, metaData, serviceType) => {
    if (selectedPosts.find((el) => el == value.id) == undefined) {
      setSelectedPosts(selectedPosts.concat(value.id));
      setProducts(
        products.concat({
          linkToPage: value.attributes.getNamedItem("data-code").value,
          img64: value.src,
          itemComment:
            socialLogo === "Twitter" ? value.attributes.getNamedItem("data-value").value : username,
          PaymentComment: username,
          quantity: 1,
          itemId: serviceItemId,
          item: selectedMenuItem,
          menuItemId: itemId,
          imgOriginalLink:
            socialLogo === "Twitter"
              ? JSON.stringify([serviceType, twitterData])
              : JSON.stringify([serviceType, metaData]),
          selectedSubCategory: selectedSubCategory,
          postData: [postData[0]],
        })
      );
      localStorage.setItem("products", JSON.stringify(products));
    } else {
      setSelectedPosts(selectedPosts.filter((el) => el != value.id));
      setProducts(products.filter((el) => el.linkToPage != value.id));
      localStorage.setItem("products", JSON.stringify(products));
    }
  };

  const addPost = async (value, metaData, serviceType) => {
    const tempProducts = [
      {
        linkToPage: value?.attributes?.getNamedItem("data-code")?.value ? null : username,
        img64: value?.src,
        itemComment: username,
        PaymentComment: username,
        quantity: 1,
        itemId: serviceItemId,
        item: selectedMenuItem,
        imgOriginalLink: JSON.stringify([serviceType, metaData]),
        menuItemId: itemId,
        selectedSubCategory: selectedSubCategory,
        postData: [postData[0]],
      },
    ];
    setProducts(tempProducts);
    localStorage.setItem("products", JSON.stringify(tempProducts));
  };

  const paymentMethodPopup = () => {
    if (!products?.length) {
      // TODO: Display error messages/labels
      return;
    }
    togglePopup();
  };

  const toCheckout = (value) => {
    if (!products.length) {
      // TODO: Display error messages/labels
      return;
    } else {
      localStorage.setItem("products", JSON.stringify(products));
      localStorage.setItem("email", JSON.stringify(email));
      navigate(`/checkout/${value}`);
    }
  };

  const toCart = () => {
    if (!products.length) {
      return;
    }
    if (!loggedUser?.id) {
      const oldCart = localStorage.getItem("cart");
      let tempProducts = JSON.parse(oldCart);
      if (!tempProducts) {
        tempProducts = [];

        tempProducts = [...tempProducts, ...products];
      } else {
        tempProducts = [...tempProducts, ...products];
      }
      navigate("/cart");
      localStorage.setItem("cart", JSON.stringify(tempProducts));
    } else {
      setIsLoading(true);
      addCartItem(loggedUser, token, products)
        .then((response) => {
          if (response.ok) {
            setIsLoading(false);
            setHasError(false);
            setError("");
          }
          return response.json();
        })
        .catch((error) => {
          setHasError(true);
          setError("Invalid Adding to Cart, please try again");
        })
        .finally(() => {
          setIsLoading(false);
          navigate("/cart");
        });
    }
  };

  const showMainContent =
    selectedSubCategory?.nameOfService === "InstaImages" ||
    selectedSubCategory?.nameOfService === "InstaComments" ||
    selectedSubCategory?.nameOfService === "InstaCustomComments" ||
    selectedSubCategory?.nameOfService === "InstaVideo" ||
    selectedSubCategory?.nameOfService === "InstaCustomComments" ||
    selectedSubCategory?.nameOfService === "FacebookCustomComment" ||
    selectedSubCategory?.nameOfService === "YoutubeCustomComments" ||
    selectedSubCategory?.nameOfService === "TikTokCustomComments" ||
    selectedSubCategory?.nameOfService === "TikTokComments" ||
    selectedSubCategory?.nameOfService === "TwitterPost" ||
    selectedSubCategory?.nameOfService === "TikTokPost";

  return (
    <section className="my-20">
      <Helmet>
        <title>Dailysocialboost | Posts</title>
      </Helmet>
      <h2 className="text-center text-5xl font-bold my-16">Select Posts</h2>
      <div className="mx-10 flex flex-col lg:flex-row justify-center gap-5">
        <div className={`${showMainContent ? "basis-7/12" : "basis-0"}`}>
          {selectedSubCategory?.nameOfService === "InstaDefault" ? <InstaDefault /> : null}
          {selectedSubCategory?.nameOfService === "InstaImages" ||
          selectedSubCategory?.nameOfService === "InstaComments" ||
          selectedSubCategory?.nameOfService === "InstaCustomComments" ||
          selectedSubCategory?.nameOfService === "InstaVideo" ? (
            <InstaImages
              selectImage={selectImage}
              postData={postData}
              selectedPosts={selectedPosts}
              loadMorePosts={loadMorePosts}
              isLoading={isLoading}
              hasError={hasError}
              serviceItem={selectedMenuItem}
              serviceType={selectedSubCategory?.nameOfService}
            />
          ) : null}
          {selectedSubCategory?.nameOfService === "InstaCustomComments" ? (
            <FacebookComment
              handleChangeFacebookComments={handleChangeFacebookComments}
              maxComments={
                products ? (products[0]?.item != null ? products[0]?.item[0].quantity : null) : null
              }
            />
          ) : null}
          {selectedSubCategory?.nameOfService === "FacebookPage" ||
          selectedSubCategory?.nameOfService === "FacebookPosts" ||
          selectedSubCategory?.nameOfService === "FacebookDefault" ||
          selectedSubCategory?.nameOfService === "FacebookComment" ||
          selectedSubCategory?.nameOfService === "FacebookProfile" ? (
            <FacebookPage />
          ) : null}
          {selectedSubCategory?.nameOfService === "FacebookCustomComment" ? (
            <FacebookComment
              handleChangeFacebookComments={handleChangeFacebookComments}
              maxComments={
                products ? (products[0]?.item != null ? products[0]?.item[0].quantity : null) : null
              }
            />
          ) : null}
          {selectedSubCategory?.nameOfService === "YoutubeVideo" ||
          selectedSubCategory?.nameOfService === "YoutubeChannel" ? (
            <Youtube handleChangeFacebookComments={handleChangeFacebookComments} />
          ) : null}
          {selectedSubCategory?.nameOfService === "YoutubeCustomComments" ? (
            <FacebookComment
              handleChangeFacebookComments={handleChangeFacebookComments}
              maxComments={
                products ? (products[0]?.item != null ? products[0]?.item[0].quantity : null) : null
              }
            />
          ) : null}
          {selectedSubCategory?.nameOfService === "SoundCloudArtist" ||
          selectedSubCategory?.nameOfService === "SoundCloudTrack" ? (
            <Soundcloud handleChangeFacebookComments={handleChangeFacebookComments} />
          ) : null}
          {selectedSubCategory?.nameOfService === "TikTokProfile" ? (
            <Soundcloud handleChangeFacebookComments={handleChangeFacebookComments} />
          ) : null}
          {selectedSubCategory?.nameOfService === "TikTokPost" ||
          selectedSubCategory?.nameOfService === "TikTokComments" ? (
            <TikTokImages
              selectImage={selectImage}
              postData={postData}
              isLoading={isLoading}
              hasError={hasError}
              selectedPosts={selectedPosts}
              loadMorePosts={loadMorePostsTikTok}
              serviceItem={selectedMenuItem}
              serviceType={selectedSubCategory?.nameOfService}
            />
          ) : null}
          {selectedSubCategory?.nameOfService === "TikTokCustomComments" ? (
            <>
              <TikTokImages
                selectImage={selectImage}
                postData={postData}
                isLoading={isLoading}
                hasError={hasError}
                selectedPosts={selectedPosts}
                loadMorePosts={loadMorePostsTikTok}
                serviceItem={selectedMenuItem}
                serviceType={selectedSubCategory?.nameOfService}
              />
              <FacebookComment
                handleChangeFacebookComments={handleChangeFacebookComments}
                maxComments={
                  products
                    ? products[0]?.item != null
                      ? products[0]?.item[0].quantity
                      : null
                    : null
                }
              />
            </>
          ) : null}
          {selectedSubCategory?.nameOfService === "TwitterPost" ? (
            <>
              <TwitterPost
                selectImage={selectImage}
                postData={postData}
                isLoading={isLoading}
                hasError={hasError}
                selectedPosts={selectedPosts}
                loadMorePosts={loadMorePostsTwitter}
                serviceType={selectedSubCategory?.nameOfService}
              />
            </>
          ) : null}
        </div>
        <div
          className={`${
            showMainContent ? "basis-5/12" : "basis-7/12"
          } p-5 border border-gray-350 rounded-3xl`}
        >
          <ItemPreview
            socialLogo={socialLogo}
            postData={postData}
            products={products}
            selectedSubCategory={selectedSubCategory}
            youtube={youtube}
            twitterData={twitterData}
            username={username}
            metadata={metadataGlobal}
          />
          <div className="text-center flex flex-col lg:flex-row justify-center gap-2">
            <button
              className={`mt-2 px-10 py-1 ${styles.postsBtn}`}
              type="button"
              value="To Checkout"
              onClick={paymentMethodPopup}
            >
              To Checkout
            </button>
            <button
              className={`mt-2 px-10 py-1 ${styles.postsBtn}`}
              type="button"
              value="To Cart"
              onClick={toCart}
            >
              To Cart
            </button>
          </div>
        </div>
      </div>
      {showPopup ? (
        <GeneralPopup title="Payment processor" closePopup={togglePopup}>
          <div className="flex flex-row flex-wrap justify-evenly py-10">
            <button
              className={`px-10 py-10 w-64 ${styles.postsWalletBtn} items-center`}
              onClick={() => toCheckout(1)}
            >
              <span>
                <img className="h-8 w-8" src={CoinbaseIcon} alt="coinbase" />
              </span>
              <span>Coinbase</span>
            </button>
            {loggedUser ? (
              <button
                className={`px-10 py-10 w-64 ${styles.postsWalletBtn} items-center`}
                onClick={() => toCheckout(2)}
              >
                <span>
                  <WalletIcon className="h-8 w-8 text-blue-500" />
                </span>
                <span>Wallet</span>
              </button>
            ) : null}
          </div>
        </GeneralPopup>
      ) : null}
    </section>
  );
}
